import React from 'react';
import PropTypes from 'prop-types';

import ProviderSurgeIncentiveSearchForm from './provider-surge-incentive-search-form-container';
import ProviderSurgeIncentiveCreateForm from './provider-surge-incentive-create-form-container';
import ProviderSurgeIncentiveSearchResults from './provider-surge-incentive-search-results-container';
import FlashBox from '../../../flash-box/flash-box';

const ProviderSurgeIncentive = ({ flashMessage }) => (
  <div className="provider-surge-incentive">
    {flashMessage && <FlashBox message={flashMessage} />}
    <h3 className="provider-surge-title">Provider Surge Incentives</h3>
    <div className="provider-incentive-cost-root">
      <div>
        <ProviderSurgeIncentiveSearchForm />
        <hr />
        <ProviderSurgeIncentiveCreateForm />
      </div>
      <div className="display-area">
        <ProviderSurgeIncentiveSearchResults />
      </div>
    </div>
  </div>
);

ProviderSurgeIncentive.propTypes = {
  flashMessage: PropTypes.string
};

export default ProviderSurgeIncentive;
